import {REMOVER_FILTRO_PRESTADOR} from '../types'

export default function removerFiltroPrestador (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_PRESTADOR
  }
}
